import { render, staticRenderFns } from "./ApisHeader.vue?vue&type=template&id=a1d6b206&scoped=true"
import script from "./ApisHeader.vue?vue&type=script&lang=js"
export * from "./ApisHeader.vue?vue&type=script&lang=js"
import style0 from "./ApisHeader.vue?vue&type=style&index=0&id=a1d6b206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d6b206",
  null
  
)

export default component.exports